import SmartToyIcon from '@mui/icons-material/SmartToy';
import { Box, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';

export const WelcomeMessage = () => {
  const { t } = useTranslation();

  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      height="100%"
      p={3}
    >
      <SmartToyIcon sx={{ fontSize: 48, color: 'primary.main', mb: 2 }} />
      <Typography variant="h6" gutterBottom>
        {t('aiChat.welcome.heading')}
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center">
        {t('aiChat.welcome.body')}
      </Typography>
    </Box>
  );
};
